import { Box } from "@mui/material";
import DataGridComponent from "../components/datagrid/datagrid.component";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import { fetchFieldsTypeStart } from "../store/features/fieldsType/fieldsTypeSlice";
import { useNavigate } from "react-router";
import { getRouterPaths } from "../router/routerPaths";
import { getFieldsTypeActions } from "../utils/fieldsTypeUtils";
import {
  deleteFieldTypeStart,
  resetCreateFieldTypeState,
  resetUpdateFieldTypeState,
} from "../store/features/fieldType/fieldTypeSlice";
import CustomDialog from "../components/muiDialogs/dialog.component";
import { dialogMessages } from "../components/forms/utils";
import { useIsMobile } from "../hook/useIsMobile";
import {
  createFieldTypeColumns,
  createFieldTypeRowsData,
} from "../config/tables/fieldType.config";

const FieldsTypePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const [searchQuery, setSearchQuery] = useState("");
  const searchTimeoutRef = useRef();

  const type = useSelector((state) => state?.me?.data?.data?.type);
  const accessToken = useSelector((state) => state.auth?.user?.access_token);
  const fieldsTypeData = useSelector((state) => state.fieldsType?.data?.data);
  const isFieldsTypeLoading = useSelector(
    (state) => state.fieldsType?.isLoading
  );
  const { success } = useSelector((state) => state.fieldType);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedFieldType, setSelectedFieldType] = useState(null);
  const [selectedAction, setSelectedAction] = useState("");

  const rows = fieldsTypeData?.map(createFieldTypeRowsData);
  const routerPaths = getRouterPaths(type);

  const fieldTypeActions = getFieldsTypeActions({
    navigate,
    routerPaths,
    setSelectedFieldType,
    setSelectedAction,
    setDialogOpen,
  });

  const columns = createFieldTypeColumns(fieldTypeActions);

  const handleSearchChange = useCallback((value) => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    searchTimeoutRef.current = setTimeout(() => {
      setSearchQuery(value);
    }, 500);
  }, []);

  const handleDialogConfirm = () => {
    if (selectedFieldType) {
      dispatch(
        deleteFieldTypeStart({ fieldTypeId: selectedFieldType, accessToken })
      );
      setDialogOpen(false);
      setSelectedFieldType(null);
      setSelectedAction("");
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedFieldType(null);
    setSelectedAction("");
  };

  useEffect(() => {
    if (type === "Admin") {
      dispatch(fetchFieldsTypeStart({ accessToken, search: searchQuery }));
    }
  }, [dispatch, type, accessToken, searchQuery]);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (success) {
      dispatch(resetCreateFieldTypeState());
      dispatch(resetUpdateFieldTypeState());
    }
  }, [dispatch, success]);

  return (
    <Box width="100%">
      <DataGridComponent
        rows={rows}
        columns={columns}
        inputPlaceholder="Cerca tipologia"
        onSearchChange={handleSearchChange}
        marginTop={5}
        showButton
        buttonLabel={"Nuova tipologia"}
        buttonHref={`/${type?.toLowerCase()}/fieldsType/addFieldType`}
        isMobile={isMobile}
        loading={isFieldsTypeLoading}
      />
      <CustomDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleDialogConfirm}
        title={dialogMessages.fieldType[selectedAction]?.title}
        description={dialogMessages.fieldType[selectedAction]?.description}
        confirmLabel={dialogMessages.fieldType[selectedAction]?.confirmLabel}
        actions={fieldTypeActions}
      />
    </Box>
  );
};

export default FieldsTypePage;
